import React from 'react';
import { observer } from 'mobx-react';
import { NikoTemplateCreateTemplate } from 'themes/application/niko-patient/components';

@observer
class NikoTemplateCreate extends React.Component {
    render() {
        return <NikoTemplateCreateTemplate {...this.props} />
    }
}

export default NikoTemplateCreate;